import { Navigate } from 'react-router-dom';
import { type ReactNode } from 'react';

export default function CustomerGate({ children }: { children: ReactNode }) {
  const allowedDomains = ['cuno.et360.de', 'localhost', 'public.et360.de'];
  const currentDomain = window.location.hostname;

  if (!allowedDomains.includes(currentDomain) && !currentDomain.startsWith('192.168.')) {
    return <Navigate to="/error" replace />;
  }

  return children;
}